module.exports = __webpack_public_path__ + "img/zx1.5763284c.png";